import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceTypeMediaComponent } from './service-type-media.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [ServiceTypeMediaComponent],
  imports: [CommonModule, SplitButtonModule, ButtonModule, TooltipModule],
  exports: [ServiceTypeMediaComponent],
})
export class ServiceTypeMediaModule {}
